export const portfolioData = {
  personal: {
    name: "Prathamesh Deshpande",
    title: "Software Developer",
    tagline: "Building scalable backend systems with microservices & event-driven architecture",
    bio: "Software Developer with 2.5 years of experience in the Fintech domain at TCS (Digital Cadre). Experienced in building scalable backend systems using microservices and event-driven architecture with Spring Boot and Apache Kafka, with a strong focus on concurrency, error handling, and system design.",
    photo: "https://customer-assets.emergentagent.com/job_05f07ed9-0a09-4319-8573-7460054d9d1b/artifacts/cjuxxz4n_WhatsApp%20Image%202026-01-21%20at%2020.12.51.jpeg",
    email: "prathameshdeshpande25@gmail.com",
    phone: "+91 7972809068",
    linkedin: "https://linkedin.com/in/prathamesh25",
    github: "https://github.com/PrathameshDeshpande",
    medium: "https://medium.com/@prtdesh25",
    resumeUrl: "/resume.pdf",
    location: "Bengaluru, India"
  },

  stats: [
    { label: "Years Experience", value: "2+" },
    { label: "Projects Delivered", value: "5+" },
    { label: "CodeChef", value: "4★" },
    { label: "Awards", value: "2" }
  ],

  skills: {
    languages: [
      { name: "Java", level: 90 },
      { name: "Python", level: 80 },
      { name: "JavaScript", level: 80 }
    ],
    frameworks: [
      { name: "Spring Boot", level: 95 },
      { name: "Spring MVC", level: 90 },
      { name: "Spring Security", level: 85 },
      { name: "Spring Data", level: 88 },
      { name: "Hibernate", level: 85 },
      { name: "React.js", level: 80 },
      { name: "Redux Toolkit", level: 75 }
    ],
    cloud: [
      { name: "AWS EC2", level: 85 },
      { name: "AWS Lambda", level: 80 },
      { name: "AWS SNS", level: 80 },
      { name: "AWS Bedrock", level: 75 },
      { name: "CloudWatch", level: 80 },
      { name: "Apache Kafka", level: 88 },
      { name: "Docker", level: 80 }
    ],
    databases: [
      { name: "PostgreSQL", level: 90 },
      { name: "Redis", level: 85 },
      { name: "Amazon DynamoDB", level: 75 }
    ],
    tools: [
      { name: "Git", level: 90 },
      { name: "Jenkins", level: 80 },
      { name: "CI/CD Pipelines", level: 82 },
      { name: "Prometheus", level: 78 },
      { name: "Grafana", level: 78 }
    ],
    concepts: [
      { name: "Microservices", level: 90 },
      { name: "REST APIs", level: 92 },
      { name: "Event-Driven Architecture", level: 88 },
      { name: "TDD", level: 82 },
      { name: "Multithreading & Concurrency", level: 85 },
      { name: "LLD", level: 85 },
      { name: "HLD", level: 80 }
    ],
    ai: [
      { name: "RAG Pipelines", level: 82 },
      { name: "Vector Embeddings", level: 78 },
      { name: "LangChain", level: 75 },
      { name: "Prompt Engineering", level: 80 },
      { name: "Machine Learning", level: 70 }
    ]
  },

  experience: [
    {
      id: 1,
      company: "Tata Consultancy Services",
      role: "Software Developer (Digital Cadre)",
      location: "Bengaluru, India",
      period: "October 2023 - Present",
      type: "Full-time",
      description: "Building scalable backend systems for a digital lending platform in the Fintech domain.",
      projects: [
        {
          name: "Digital Lending Platform - Core Services",
          highlights: [
            "Reduced portfolio valuation latency from 280ms to 18ms by implementing a Redis Write-Through cache and an async scheduler to pre-warm NAVs for 4,500+ schemes after daily AMFI updates.",
            "Developed an idempotent Apache Kafka consumer processing 35,000+ loans to detect NAV drops, forwarding flagged accounts to Margin-Evaluation and isolating failed messages via DLQ.",
            "Integrated MFCentral APIs across distributed services with validation rules for asset eligibility, and configured Resilience4j circuit breaker and retry for graceful degradation, reducing failure propagation by 40% during upstream outages.",
            "Used Version-based optimistic locking to prevent race conditions across concurrent pledge requests, and enforced idempotency on Revoke-Lien calls to ensure safe retry behavior on failed bookings, eliminating duplicate lien releases.",
            "Contributed to decomposing monolithic lending modules into independently deployable Spring Boot microservices on AWS using the strangler fig pattern, involving RDS per bounded context, API Gateway integration, and service discovery setup."
          ]
        },
        {
          name: "Notifications, Observability & GenAI Initiatives",
          highlights: [
            "Built and deployed a repayment notification service using Spring Boot and AWS SNS, integrating it into the loan booking flow to reduce overdue account follow-ups by 20%.",
            "Built observability using CloudWatch, Prometheus, and Grafana to track service health and SLOs, reducing mean time to detect (MTTD) incidents by 60%, and followed TDD practices to achieve 73% unit test coverage using JUnit and Mockito, reducing bug escapes by 40%.",
            "Developed an internal RAG-based Knowledge Retrieval System using GenAI to index legacy documentation, significantly reducing technical query resolution time for senior developers."
          ]
        }
      ],
      technologies: ["Java", "Spring Boot", "Apache Kafka", "Redis", "PostgreSQL", "AWS", "Microservices", "Resilience4j", "Prometheus", "Grafana"]
    }
  ],

  projects: [
    {
      id: 1,
      title: "ExamFlow",
      description: "Online examination platform with a Spring Boot REST API and a React-based frontend, featuring a RAG-based question generation pipeline and role-based dashboards for teachers and students.",
      highlights: [
        "Built a Spring Boot REST API implementing a RAG-based pipeline that chunks uploaded documents, generates vector embeddings, and retrieves relevant context before calling OpenAI for question generation.",
        "Developed a React-based frontend for teachers and students with role-based dashboards, integrating JWT authentication, real-time exam interactions, and seamless API communication with the backend."
      ],
      technologies: ["Spring Boot", "React", "PostgreSQL", "Redis", "JWT", "RAG Pipeline"],
      featured: true
    },
    {
      id: 2,
      title: "BookMyFlick",
      description: "Movie ticket booking platform along the lines of BookMyShow, built on a microservices backend that handles show listings, seat selection, payments, and notifications across multiple cinemas and cities.",
      highlights: [
        "Split the system into independent Spring Boot services for catalog, booking, payments, and notifications, with Apache Kafka used for cross-service events so that booking confirmations, payment updates, and seat releases stay consistent without tight coupling between services.",
        "Handled concurrent seat reservations using Redis-based distributed locks combined with version-based optimistic locking on booking records, preventing double bookings during peak show releases and rolling back held seats safely whenever a payment failed or timed out."
      ],
      technologies: ["Spring Boot", "Microservices", "Apache Kafka", "Redis", "PostgreSQL", "Docker"],
      featured: true
    },
    {
      id: 3,
      title: "SikeTool",
      description: "Note-taking application that quietly studies a user's daily journal entries to surface patterns related to mood, stress, and early signs of depression or anxiety, paired with an analytics dashboard built for therapists and psychiatrists to follow patient progress between sessions.",
      highlights: [
        "Designed a clean journaling experience on the user side, where each entry is processed by a language model on the backend to extract sentiment, recurring themes, and well-established indicators associated with depression and anxiety, all stored in a structured timeline for the user to revisit.",
        "Built a separate clinician dashboard that aggregates a patient's entries into weekly mood trends, risk-level summaries, and topic clusters, giving therapists a clearer view of how a patient is doing over time and helping them prepare for sessions with concrete data points instead of memory alone."
      ],
      technologies: ["Python", "FastAPI", "React", "PostgreSQL", "OpenAI", "Chart.js"],
      featured: true
    }
  ],

  education: {
    institution: "SRM Institute of Science and Technology",
    degree: "Bachelor of Technology",
    major: "Computer Science and Engineering",
    period: "June 2019 - June 2023",
    cgpa: "9.24",
    location: "Chennai, India"
  },

  achievements: [
    {
      id: 1,
      title: "AWS Certified Solutions Architect - Associate",
      description: "Amazon Web Services certification validating expertise in designing distributed systems and cloud-based architectures on AWS.",
      date: "Certified",
      icon: "award"
    }
  ],

  testimonials: [
    {
      id: 1,
      name: "Tech Lead",
      role: "Senior Architect, TCS",
      content: "Prathamesh consistently delivers high-quality code and demonstrates exceptional problem-solving skills in complex distributed systems.",
      avatar: "https://api.dicebear.com/7.x/avataaars/svg?seed=1"
    },
    {
      id: 2,
      name: "Project Manager",
      role: "Delivery Manager, Kotak Project",
      content: "His optimization work on the portfolio valuation service was remarkable. Reduced latency by 97% while maintaining code quality.",
      avatar: "https://api.dicebear.com/7.x/avataaars/svg?seed=2"
    }
  ]
};
